import { Btn, H4, Image, LI, P, UL } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { Link } from "react-router-dom";
import { ToggleModalProp } from "../../../../Type/UiKits";
import { AlreadyLeaving, YesLogOut } from "../../../../Constant";

export const ToggleChildModal = ({toggleAll}: ToggleModalProp) => {
  return (
    <div className="modal-toggle-wrapper">
      <UL className="modal-img simple-list">
        <LI className="text-center"><Image src={dynamicImage("gif/logout.gif")} alt="logout" /></LI>
      </UL>
      <H4 className="pt-3 text-center">{AlreadyLeaving}</H4>
      <P className="text-center">Are you sure want to logout this dashboard?</P>
      <span className="d-block text-center mb-4">Not a member?
        <Link className="ms-1" to={`${process.env.PUBLIC_URL}/dashboard/default`}>Register</Link>
      </span>
      <Btn color="dark" className="d-flex m-auto" type="button" onClick={toggleAll}>{YesLogOut}</Btn>
    </div>
  );
};
